import React, { useEffect, useState } from 'react'
import { Flex } from 'front-end/src/components'
import { Trans } from '@lingui/macro'
import dayjs from 'shared/dayjs'
import DatePicker from '../../../../../components/common/date-time-pickers/DatePicker'
import { css } from '@emotion/react'
import { useEditCampaignFilterContext } from 'front-end/src/pages/manage-campaign-page/components/campaign-audience/modals/enrolment-modal/EditCampaignFilterContext'

export const EditCampaignFilterDateRange = ({ setTemporalComparator }) => {
  const { editedFilter } = useEditCampaignFilterContext()
  const [fromDate, setFromDate] = useState(
    dayjs(editedFilter.temporalComparator?.range?.fromDate).startOf('day') ||
      dayjs().startOf('day')
  )
  const [toDate, setToDate] = useState(
    editedFilter.temporalComparator?.range?.toDate
      ? dayjs(editedFilter.temporalComparator?.range?.toDate).endOf('day')
      : dayjs().add(1, 'week').endOf('day')
  )

  useEffect(() => {
    setTemporalComparator({
      range: {
        fromDate: fromDate.toISOString(),
        toDate: toDate.toISOString()
      }
    })
  }, [fromDate, toDate])

  return (
    <Flex>
      <Flex align="center" mr="16px" w="164px" justify="end">
        <Trans>from</Trans>
      </Flex>

      <Flex>
        <DatePicker
          css={css`
            max-width: 140px;
          `}
          value={fromDate ? dayjs(fromDate).format('L') : ''}
          onChange={(value) => {
            setFromDate(dayjs(value.toString()))
          }}
        />

        <Flex align="center" mx="16px" textAlign="right">
          <Trans>to</Trans>
        </Flex>

        <DatePicker
          css={css`
            max-width: 140px;
          `}
          value={toDate ? dayjs(toDate).format('L') : ''}
          onChange={(value) => {
            setToDate(dayjs(value.toString()).endOf('day'))
          }}
        />
      </Flex>
    </Flex>
  )
}
